import React from "react";

import { Button as MuiButton, ButtonProps } from "@mui/material";

interface IProps extends ButtonProps {
  label?: string;
  error?: boolean;
  size?: "small" | "medium" | "large";
  color?: "inherit" | "primary" | "secondary";
  variant?: "contained" | "outlined" | "text";
  textTransform?: "uppercase" | "lowercase" | "capitalize" | "none";
}

export const Button: React.FC<IProps> = ({
  label,
  children,
  error = false,
  size = "medium",
  color = "primary",
  variant = "contained",
  textTransform = "none",
  ...props
}) => {
  return (
    <MuiButton
      {...props}
      size={size}
      color={color}
      variant={variant}
      style={{
        textTransform,
        color: error ? "#F50000" : undefined,
        borderColor: error ? "#F50000" : undefined,
      }}
    >
      {label}
      {children}
    </MuiButton>
  );
};
